module.exports = __webpack_public_path__ + "static/img/metrotv-selamat-pagi-indonesia-24-oktober-2019.9391369.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/articles/191029/metrotv-selamat-pagi-indonesia-24-oktober-2019.png
// module id = xzEX
// module chunks = 1